;(() => {
    const carousel = document.querySelector('.c-carousel');

    if ( carousel === null ) return;
    
    
    carousel.addEventListener('click', function(clickEvent) {
        let view = this.querySelector('.c-carousel__view');
        
        for(let item of view.childNodes) {
            if ( item.nodeName === '#text' ) 
            view.removeChild(item)
        }
        
        
        let target = clickEvent.target;
        let line = this.querySelector('.c-carousel__line');
        if ( target.hasAttribute('data-slide-to') ) {
            clickEvent.preventDefault();
            view.setAttribute('style', `left: 0px`);

            let index = target.getAttribute('data-slide-to');
            this.querySelectorAll('.is-active').forEach((item) => {
                item.classList.remove('is-active');
            });

            target.classList.add('is-active');
            view.childNodes[index].classList.add('is-active');
            view.setAttribute('style', `left: -${view.offsetWidth * index}px`);

            line.childNodes[0].style.width = `${(line.offsetWidth / 6) * index}px`;

            this.querySelectorAll('.has-activity').forEach((item) => {
                item.classList.remove('has-activity');
            });
            let navItems = this.querySelectorAll('.c-carousel__nav-item a');
            for ( let i = 0; i < index; i++ ) {
                navItems[i].classList.add('has-activity');
            }
            
        }
    });
    
})()